// removed by extract-text-webpack-plugin
module.exports = {"task":"src-display-platform-InBox-Task-index__task--1YzzL"};


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/InBox/Task/index.scss
// module id = 4421
// module chunks = 0